import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { TicketHeader, TicketsCard, TicketsCardWrapper } from "./style";
import SingleTicket, { ViewAllTickets } from "./SingleTickets";
import { useGetTicketsByUserIdQuery } from "../../../../../../redux/features/tickets/ticketsApi";
import { adminDashboardRoute } from "../../../../../../utils/routes/Routes";
import { Typography } from "@mui/material";
import { useAuth } from "../../../../../../utils/hooks/useAuth";
import { FormattedMessage } from "react-intl";

const RecentTickets = ({ tickets }) => {
  const navigate = useNavigate();

  // STATE
  const [filters, setFilters] = useState({
    ticket_status: null,
    category: null,
    company_name: null,
    updated_at: null,
    created_at: null,
  });

  const handleViewAllClick = () => {
    navigate(adminDashboardRoute.tickets);
  };

  return (
    <TicketsCardWrapper>
      <TicketsCard>
        <TicketHeader>
          <Typography variant="h3" component="h3">
            <FormattedMessage id="dashboard.recentTickets" />
          </Typography>
          <Typography variant="body2" component="p">
            <FormattedMessage id="dashboard.recentTickets.subtitle" />
          </Typography>
        </TicketHeader>
        {tickets?.paginated_results?.slice(0, 5).map((ticket, index) => (
          <SingleTicket
            key={index}
            name={ticket.company_name}
            status={ticket.status}
            date={ticket.created_at}
            action={ticket.title}
          />
        ))}
        <ViewAllTickets onClick={handleViewAllClick} />
      </TicketsCard>
    </TicketsCardWrapper>
  );
};

export default RecentTickets;
